<template>
  <tr>
    <td v-if="!switch_edit">{{ user.enduser_na }}</td>
    <td v-if="switch_edit">
      <input
        type="text"
        class="form-control"
        :class="{
          'is-invalid':
            errorResponse.ngfg_endUserNa || errorResponse.ngfg_deliveryCd
        }"
        v-model="input_enduser_na"
      />
      <div class="invalid-feedback" v-if="errorResponse.ngfg_endUserNa">
        {{ errorResponse.msg_endUserNa }}
      </div>
      <div class="invalid-feedback" v-if="errorResponse.ngfg_deliveryCd">
        {{ errorResponse.msg_deliveryCd }}
      </div>
    </td>
    <!-- 20200521 ユーザリストはユーザ名のみ表示のため削除
    <td v-if="!switch_edit">{{ user.enduserkana_na }}</td>
    <td v-if="switch_edit">
      <input
        type="text"
        class="form-control"
        :class="{ 'is-invalid': errorResponse.ngfg_endUserKanaNa }"
        v-model="input_enduserkana_na"
      />
      <div class="invalid-feedback" v-if="errorResponse.ngfg_endUserKanaNa">
        {{ errorResponse.msg_endUserKanaNa }}
      </div>
    </td>
    -->
    <td class="btn_usr text-center">
      <button
        class="btn btn-sm btn-primary mr10"
        v-if="!switch_edit"
        @click="editMode"
      >
        編集
      </button>
      <button
        class="btn btn-sm btn-info"
        v-if="!switch_edit"
        @click="delEndUserList"
      >
        削除
      </button>
      <button
        class="btn btn-sm btn-primary mr10"
        v-if="switch_edit"
        @click="editEndUserListHandler"
      >
        保存
      </button>
      <button
        class="btn btn-sm btn-info pl0"
        v-if="switch_edit"
        @click="switch_edit = false"
      >
        キャンセル
      </button>
    </td>
  </tr>
</template>

<script>
import { store as UserStore } from "../../store/UserList";

export default {
  props: {
    user: { type: Object, required: true }
  },
  data() {
    return {
      switch_edit: false,

      // Edit End User
      input_enduser_na: "",
      //input_enduserkana_na: "",
      errorResponse: []
    };
  },
  methods: {
    editMode() {
      this.errorResponse = [];
      this.input_enduser_na = this.$props.user.enduser_na;
      //this.input_enduserkana_na = this.$props.user.enduserkana_na;
      this.switch_edit = true;
    },
    /**
     * Update EndUser
     */
    async editEndUserListHandler() {
      this.errorResponse = [];

      const response = await this.postAsteria("CommonAPI", "editEndUserList", {
        delivery_cd: UserStore.deliveryCd,
        enduser_cd: this.$props.user.enduser_cd,
        enduser_na: this.input_enduser_na,
        enduserkana_na: ""
      });

      if (response.responseData.return == 0) {
        UserStore.userList = this.getAsteriaArray(
          response.responseData,
          "userList"
        );
        this.switch_edit = false;
        this.$emit("refreshList");
        return;
      } else if (response.responseData.return == 1) {
        this.errorResponse = response.responseData;
        return;
      }
    },
    /**
     * Delete EndUser
     */
    async delEndUserList() {
      this.errorResponse = [];

      const response = await this.postAsteria("CommonAPI", "delEndUserList", {
        delivery_cd: UserStore.deliveryCd,
        enduser_cd: this.$props.user.enduser_cd
      });

      if (response.responseData.return == 0) {
        UserStore.userList = this.getAsteriaArray(
          response.responseData,
          "userList"
        );
        this.switch_edit = false;
        this.$emit("refreshList");
        return;
      }
    }
  }
};
</script>
